import React, { Fragment } from 'react';
import { Box, CircularProgress, Divider, List, Typography, Fade, } from '@mui/material';
import { SearchOffOutlined} from '@mui/icons-material';
import SingleSearchResult from './SingleSearchResult';

export default function SearchResult(props) {
    const { showProductList, resultBoxRef, searchResultData, resultNotFound, loading, searchTerm,  selectedIndex
 } = props;

    return (
        <Fade in={showProductList} timeout={300}>
            <Box
                ref={resultBoxRef}
                sx={{
                    position: "absolute",
                    top: "100%",
                    mt: 1,
                    display: showProductList ? "block" : "none",
                    backgroundColor: "#ffffff",
                    minHeight: {
                        xs: "200px",
                        sm: "240px",
                        md: "280px"
                    },
                    maxHeight: {
                        xs: "300px",
                        sm: "350px",
                        md: "400px"
                    },
                    width: "100%",
                    zIndex: 9999,
                    borderRadius: {
                        xs: 2,
                        md: 3
                    },
                    boxShadow: {
                        xs: "0 8px 32px rgba(0,0,0,0.12)",
                        md: "0 12px 48px rgba(0,0,0,0.15)"
                    },
                    overflow: 'auto',
                    backdropFilter: 'blur(10px)',

                    border: '1px solid rgba(0,0,0,0.06)',
                    '&::-webkit-scrollbar': {
                        width: '4px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'transparent',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#c1c7cd',
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: '#a0a8b0',
                        }
                    },
                    '&:hover': {
                        '&::-webkit-scrollbar': {
                            display: 'block',
                        }
                    },
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                    '&:hover::-webkit-scrollbar': {
                        display: 'block',
                    },
                    'msOverflowStyle': 'none',
                    'scrollbarWidth': 'thin',
                }}>



                <List sx={{
                    py: 1,
                    '& .MuiListItem-root': {
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            backgroundColor: 'rgba(0,0,0,0.02)',
                        }
                    }
                }}>
                    {loading ? (
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: "center",
                            alignItems: "center",
                            height: {
                                xs: "200px",
                                sm: "240px",
                                md: "280px"
                            },
                            gap: 2
                        }}>
                            <CircularProgress
                                size={40}
                                sx={{
                                    color: '#3b82f6',
                                    animationDuration: '1000ms',
                                }}
                            />
                            <Typography
                                variant="caption"
                                sx={{
                                    color: '#9ca3af',
                                    fontWeight: 500,
                                    letterSpacing: '0.3px'
                                }}
                            >
                                Searching products...
                            </Typography>
                        </Box>
                    ) : (
                        <>
                            {searchResultData?.map((item, index) => (
                                <Fragment key={item?.id || index}>
                                    <SingleSearchResult item={item} 
                                    searchTerm={searchTerm} 
                                      isSelected={index === selectedIndex}
/>
                                    {index < searchResultData.length - 1 && (
                                        <Divider sx={{
                                            mx: 2,
                                            opacity: 0.4
                                        }} />
                                    )}
                                </Fragment>
                            ))}
                        </>
                    )}

                    {(resultNotFound && !loading) && (
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: "center",
                            alignItems: "center",
                            height: {
                                xs: "220px",
                                sm: "260px",
                                md: "300px"
                            },
                            gap: 2,
                            px: 3,
                            textAlign: 'center'
                        }}>
                            <Box sx={{
                                width: 64,
                                height: 64,
                                borderRadius: '50%',
                                backgroundColor: 'rgba(0,0,0,0.04)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mb: 1
                            }}>
                                <SearchOffOutlined sx={{
                                    fontSize: 32,
                                    color: '#9ca3af'
                                }} />
                            </Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontSize: {
                                        xs: "1rem",
                                        sm: "1.1rem",
                                        md: "1.25rem"
                                    },
                                    fontWeight: 600,
                                    color: "#111827",
                                    mb: 0.5
                                }}
                            >
                                No Results Found
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontSize: {
                                        xs: "0.8rem",
                                        md: "1.1rem"
                                    },
                                    color: "#000",
                                    maxWidth: 300,
                                   wordSpacing:1,
                                }}
                            >
                                We couldn't find any products matching your search. Try adjusting your keywords.
                            </Typography>
                            <Box sx={{
                                display: 'flex',
                                gap: 1,
                                mt: 1,
                                flexWrap: 'wrap',
                                justifyContent: 'center'
                            }}>

                            </Box>
                        </Box>
                    )}
                </List>

                {/* Quick Action Footer */}
                {!loading && !resultNotFound && searchResultData?.length > 2 && (
                    <Box sx={{
                        px: 3,
                        py: 1.5,
                        borderTop: '1px solid rgba(0,0,0,0.06)',
                        display: 'flex',
                        justifyContent: 'center',
                        bgcolor: 'rgba(0,0,0,0.01)'
                    }}>
                        <Typography
                            variant="caption"
                            sx={{
                                color: '#3b82f6',
                                fontWeight: 500,
                                fontSize: '0.75rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                cursor: 'pointer',
                                '&:hover': {
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            View All Results
                            <Box component="span" sx={{ ml: 0.5 }}>→</Box>
                        </Typography>
                    </Box>
                )}
            </Box>
        </Fade>
    )
}